import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { canManageGames } from '../../domain/games/policy';
import { FavoriteButton } from '../../features/games/FavoriteButton';
import { GameInfo } from '../../features/games/GameInfo';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectGameById } from '../../store/selectors/gamesSelectors';
import { deleteGame, fetchGameById } from '../../store/thunks/gamesThunks';

import './GameDetailPage.css';

export function GameDetailPage() {
  const { gameId } = useParams<{ gameId: string }>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const game = useAppSelector(selectGameById(gameId ?? ''));
  const role = useAppSelector((s) => s.auth.user?.role);
  const canManage = canManageGames(role);

  useEffect(() => {
    if (gameId) {
      dispatch(fetchGameById({ gameId }));
    }
  }, [dispatch, gameId]);

  if (!game) {
    return (
      <div className="game-detail">
        <div className="tavern-loading">
          <div className="tavern-spinner" />
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (!gameId) return;
    if (window.confirm(`Удалить игру «${game.name}»?`)) {
      await dispatch(deleteGame({ gameId }));
      navigate('/games');
    }
  };

  return (
    <div className="game-detail">
      <div className="game-detail__header">
        <button className="game-detail__back" onClick={() => navigate(-1)}>
          ← Назад
        </button>
        <FavoriteButton gameId={game.id} />
      </div>

      <GameInfo game={game} />

      {canManage && (
        <div className="game-detail__actions">
          <button
            className="tavern-btn-secondary"
            onClick={() => navigate(`/games/${game.id}/edit`)}
          >
            ✏️ Редактировать
          </button>
          <button className="tavern-btn-danger" onClick={handleDelete}>
            🗑️ Удалить
          </button>
        </div>
      )}
    </div>
  );
}
